

export const questionnaire = {
  "questionnaire_title": "Questionnaires",
  "questionnaire_questionnaire": "questions",
  "questionnaire_minutes": "minutes",
  "questionnaire_continue": "Continuer",
  "questionnaire_start": "Commencer",
  "questionnaire_point": "points"
}